import React from 'react'
import SendGlimpse from 'components/glimpses/send_glimpse'
import SendAmount from 'components/glimpses/send_glimpse/send_amount'
import SendNote from 'components/glimpses/send_glimpse/send_note'
import SendReview from 'components/glimpses/send_glimpse/send_review'
import CountryBlockedError from 'components/common/country_blocked'
import CantChipIn from 'components/glimpses/send_glimpse/cant_chip_in'
import { sendEnsightenEvent } from 'lib/ensighten_analytics'

import { resetIFrameState } from 'redux/modules/send_iframe'
import {
  trackEnter,
  trackChange,
  addGlimpselessRouteToHistory,
} from 'lib/glimpse'
import { isCampaignOwner } from 'lib/is_owner'
import { getCampaignType } from 'lib/campaign'
import { block } from 'lib/contribute'
import hasCurrencyBalanceSelector from 'redux/selectors/has_currency_balance'

import {
  glimpselessRoute,
  glimpseRoute,
  assertInitialStep,
  assignActionToRouterParams,
  completeCipVerification,
} from 'lib/route_utils'

import { CIP_FLOW_URL, POOLS_CAMPAIGN_TYPES } from '../../shared/shared_consts'

const INITIAL_SEND_STEP = 'amount'
const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

export default (store, history) => ({
  path: 'send',
  getComponent(nextState, callback) {
    if (!store.getState().isContributionEligible) {
      return callback(null, {
        glimpse: props => <CountryBlockedError {...props} showClose={true} />,
      })
    }
    return callback(null, { glimpse: SendGlimpse })
  },
  onEnter(nextState, replace) {
    trackEnter('send', nextState, replace)
    const isOwner = isCampaignOwner(store, nextState.params.campaignId)
    const campaignType = getCampaignType(store, nextState.params.campaignId)
    const hasCurrency = hasCurrencyBalanceSelector(store.getState(), {
      campaignId: nextState.params.campaignId,
    })
    if (block(store, nextState.params.campaignId)) {
      replace(glimpselessRoute('send'))
    }
    const cipNotVerified = store.getState().current_user.cipNotVerified
    if (isOwner) {
      if (campaignType === CROWD_FUNDING) {
        replace(glimpseRoute('edit', 'pledge', 'send'))
      } else {
        replace(glimpseRoute('chip_in', undefined, 'send'))
      }
    } else if (!hasCurrency) {
      if (location.pathname.indexOf('nochipin') < 0) {
        replace(glimpseRoute('send', 'nochipin'))
      }
    } else if (cipNotVerified) {
      location.href = completeCipVerification(nextState.params.campaignId)
    } else {
      store.dispatch(resetIFrameState()) // resets the send state for consecutive sends
      if (store.getState().server.isReturningFromWallet) {
        return
      }
      assertInitialStep('send', INITIAL_SEND_STEP, nextState, replace)
    }
  },
  onChange(prevState, nextState, replace) {
    assignActionToRouterParams(nextState)
    trackChange('send', prevState, nextState, replace)
  },
  childRoutes: [
    {
      path: INITIAL_SEND_STEP,
      component: SendAmount,
      onEnter(nextState, replace) {
        if (
          !nextState.location.state.initial &&
          nextState.location.action !== 'POP' &&
          !nextState.params.prevStep
        ) {
          sendEnsightenEvent('MoneyPoolSendStart')
        }
        addGlimpselessRouteToHistory('send', nextState, replace, history)
      },
    },
    { path: 'note', component: SendNote },
    { path: 'review', component: SendReview },
    { path: 'nochipin', component: CantChipIn },
    {
      path: 'cip',
      onEnter(nextState, replace) {
        if (store.getState().current_user.cipNotVerified) {
          location.href = CIP_FLOW_URL.RETURN_URL
        } else {
          assertInitialStep('send', INITIAL_SEND_STEP, nextState, replace)
        }
      },
    },
  ],
})
